import React from "react";
import "./AboutUs.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import pm from "../media/tourism/AboutUs/test1.jpg";
import logo from "../media/tourism/aboutuslogo.png"; // Your logo image
import cm from "../media/tourism/AboutUs/cm.jpg";
import cabinet from "../media/tourism/AboutUs/cabinet.jpg";
import president from "../media/tourism/AboutUs/president.jpg";
import BrochureDownload from "./BrochureDownload";

const AboutUs = () => {
  const founders = [
    { name: "Smt. Maya Devi", designation: "Chairman" },
    { name: "Rakesh Mehta", designation: "Managing Director" },
    { name: "Umesh Ojha", designation: "IT & Digital Head" },
    { name: "Santosh Kumar Mishra", designation: "Legal Manager" },
    { name: "Anil Kumar Kaushik", designation: "Field Manager" },
    { name: "Chandraprakash Singh", designation: "Civil Manager" },
  ];

  const images = [
    { src: pm, caption: "One of our Co-Founder welcoming, Hon. Prime Minister of India Shri Narendra Modi ji, in Sonbhadra" },
    { src: cm, caption: "One of our Co-Founder welcoming, Hon. Chief Minister of U.P. Shri Yogi Adityanath ji, in Sonbhadra" },
    { src: cabinet, caption: "Our Co-Founder meeting, Hon. Union Cabinet Minister of India, Shri Hardeep Singh Puri Ji, who has adopted Sonbhadra as Member of Rajya Sabha "},
    { src: president, caption: "Our Co-Founder meeting, The then Hon. President of India Shri Ramnath Kovind ji and promoting Sonbhadra Tourism" },
  ];

  const sliderSettings = {
    dots: true,
    infinite: images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  return (
    <div className="about-us__container">
  <div className="about-us__logo-container">
    <img src={logo} alt="Company Logo" className="about-us__logo" />
  </div>

  <h1 className="about-us__heading">About Us</h1>
  <p className="about-us__description">
  Welcome to Sonbhadra Tourism Pvt. Ltd., your trusted partner for exploring the enchanting beauty of Sonbhadra at an affordable cost. Headquartered in Robertsganj, Sonbhadra, we are one of the leading eco-tourism companies, committed to providing unforgettable travel experiences. Sonbhadra, known for its breathtaking natural landscapes, ancient temples, and historical marvels, offers a unique blend of adventure, spirituality, and heritage. From serene waterfalls and thrilling adventures to sacred temples and hidden gems, we ensure every journey with us is a lifetime experience. "Sonbhadra Nahi Dekha too Uttar Pradesh Nahi Dekha!"
  </p>

  <h2 className="about-us__subheading">Founders</h2>
  <ul className="about-us__founders-list">
    {founders.map((founder, index) => (
      <li key={index} className="about-us__founder-item">
        <strong>{founder.name}</strong> - {founder.designation}
      </li>
    ))}
  </ul>

  <Slider {...sliderSettings}>
    {images.map((image, index) => (
      <div key={index} className="about-us__slider-item">
        <img src={image.src} alt={image.caption} className="about-us__slider-image" />
        <p className="about-us__slider-caption">{image.caption}</p>
      </div>
    ))}
  </Slider>

  <div className="about-us__social-links">
        <ul>
          <li><a href="https://www.instagram.com/sonebhadratourism" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
          <li><a href="https://www.facebook.com/sonbhadratourism64/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a></li>
          <li><a href="https://x.com/sonbhadratour" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
          <li><a href="https://www.youtube.com/@sonebhadratourism" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a></li>
          <li><a href="https://www.linkedin.com/company/sonbhadratourism/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a></li>
        </ul>
      </div>

      <BrochureDownload />
      
       {/* Important Links Section */}
       <div className="important-links">
        <h2>Important Links</h2>
        <ul>
          <li><a href="https://www.sonbhadratourism.com/sonbhadra" target="_blank" rel="noopener noreferrer">About Sonbhadra District</a></li>
        </ul>
      </div>

  <div className="about-us__bg-image-container"></div>
</div>

  );
};

export default AboutUs;
